import React, { useState } from "react";
import "./Deposite_History_List.css";
import Common_white_header from "../../Common/Common_Component/Common_white_header/Common_white_header";
import Select from "react-select";
import { Tabs, Tab } from "react-bootstrap";
import WithdrawalFilterOffcanvas from "../../Common/Common_Component/Filter_Drop/WithdrawalFilterOffcanvas/WithdrawalFilterOffcanvas";
import DateFilterOffcanvas from "../../Common/Common_Component/Filter_Drop/DateFilterOffcanvas/DateFilterOffcanvas";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortDown } from "@fortawesome/free-solid-svg-icons";
import Deposite_History_card from "../Deposite_History/Deposite_History_card/Deposite_History_card";
import Filter_Drop from "../../Common/Common_Component/Filter_Drop/Filter_Drop";
import No_data from "../../Common/No_data/No_data";

function Deposite_History_List() {
  const [key, setKey] = useState("all");

  return (
    <>
      <section className="Withdrawal_History_List">
        <Common_white_header headingText={"Deposite History"} />

        <div className="container">
          {/* Payment Tabs */}
          <Tabs
            activeKey={key}
            onSelect={(k) => setKey(k)}
            className="mb-3 custom-tabs"
          >
            <Tab
              eventKey="all"
              title={
                <>
                  {" "}
                  <img
                    src="/assets/images/withdraw_Deposite/Payment_Method_Cards/select-all.png"
                    alt="peyment"
                    className="payment_method_img all_tab_payment_method_img"
                  />
                  All
                </>
              }
            />
            <Tab
              eventKey="upi"
              title={
                <>
                  {" "}
                  <img
                    src="/assets/images/withdraw_Deposite/Payment_Method_Cards/upi.png"
                    alt="peyment"
                    className="payment_method_img"
                  />{" "}
                  Phonepe/ Googlepay
                </>
              }
            />
            <Tab
              eventKey="phonepe"
              title={
                <>
                  {" "}
                  <img
                    src="/assets/images/withdraw_Deposite/Payment_Method_Cards/credit_card.png"
                    alt="peyment"
                    className="payment_method_img"
                  />{" "}
                  Bank Card
                </>
              }
            />
            <Tab
              eventKey="bank"
              title={
                <>
                  {" "}
                  <img
                    src="/assets/images/withdraw_Deposite/Payment_Method_Cards/usdt.png"
                    alt="peyment"
                    className="payment_method_img"
                  />{" "}
                  USDT
                </>
              }
            />
          </Tabs>

          {/* Filters Row */}
          <Filter_Drop/>

          {/* Cards */}
          <Deposite_History_card    status="Failed" badge="Deposite"  />

           <No_data/>
        </div>
      </section>

   
    </>
  );
}

export default Deposite_History_List;
